import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import SessionService from "../../../services/session-service";
import * as yup from "yup";
import { useFormik } from "formik";
import { LoginRequestBody } from "../../../services/account/login/types";
import { Input } from "../../../components/Input/input";
import { StyledButton } from "../../../components/Button/button";
import { useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { LoadingBackDrop } from "../../../components/loader";
import { theme } from "../../../helpers/theme";

import { FormWrapper } from "../forgotten-password-send-mail/styles";
import { LayoutAccount } from "../../../components/layoutAccount";

import { auth } from "../../../redux/actions";
import { useAppDispatch } from "../../../hooks/redux-hooks";
import { login } from "../../../services/account/login";
import React from "react";
import { url, urlClient } from "../../../utils/url";
import { IconButton, InputAdornment } from "@mui/material";
import { BooleanLiteral } from "@babel/types";
import { OfferFromEmailMesssage } from "../../../types/session-service";
import { getLoggedUsersData } from "../../../services/users/get-logged";
import { UserRoles } from "../../../types/user-roles";

export const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  let navigate = useNavigate();
  const isOfferPrepated: boolean = SessionService.getViewOffer()
    ? SessionService.getViewOffer().emailHasBeenSent
    : false;

  const isFinalOfferPrepared: boolean =
    SessionService.getFinalOfferForAccepance()
      ? SessionService.getFinalOfferForAccepance().emailHasBeenSent
      : false;

  const dispatch = useAppDispatch();
  const loginMutation = useMutation(login, {
    onSuccess: (res) => {
      SessionService.setUser(res.data.payload);
      dispatch(auth.userLogin(res.data.payload));
      getLoggedDataMutation.mutate();
      if (
        res.data.payload.typ_uzytkownika === UserRoles.SUBCONTRACTOR &&
        SessionService.getOfferSubcontractorView()
      ) {
        navigate(
          `/subcontractor/offer-view/${
            SessionService.getOfferSubcontractorView().id
          }`
        );
        console.log("tragfxsg");
      } else {
        navigate(
          isFinalOfferPrepared
            ? `/final-offer-view/${
                SessionService.getFinalOfferForAccepance().id
              }`
            : isOfferPrepated
            ? `/offer-view/${SessionService.getViewOffer().id}`
            : navigateAfterLogged(res.data.payload.typ_uzytkownika)
        );
      }
    },
  });
  const navigateAfterLogged = (role: UserRoles) => {
    switch (role) {
      case UserRoles.CLIENT:
        return "/orders";
      case UserRoles.OPERATOR:
        return "/operator/orders";
      case UserRoles.SUBCONTRACTOR:
        return "/subcontractor/subcontractors";
    }
  };
  const getLoggedDataMutation = useMutation(getLoggedUsersData, {
    onSuccess: (data) => {
      SessionService.setLoggedUserData(data.data.payload.dane_klient);
    },
  });

  const validationSchema = yup.object({
    login: yup
      .string()
      .required("Login jest wymagany")
      // .email("Błędny format pola Login")
      .max(50, "Błędny format pola Login. Maksymalnie 50 znaków")
      .min(3, "Błędny format pola Login. Minimalnie 3 znaki"),
    haslo: yup
      .string()
      .required("Hasło jest wymagane")
      .max(50, "Maksymalnie 50 znaków"),
  });
  const formik = useFormik({
    initialValues: {
      login: "",
      haslo: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = {
        login: values.login,
        haslo: btoa(values.haslo),
      };
      loginMutation.mutate(body);
    },
  });
  if (loginMutation.isLoading) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <LayoutAccount>
      <LoginForm onSubmit={formik.handleSubmit}>
        <FormWrapper>
          <Input
            label="Login"
            id="login"
            name="login"
            value={formik.values.login}
            onChange={formik.handleChange}
            error={formik.touched.login && Boolean(formik.errors.login)}
            helperText={formik.touched.login && formik.errors.login}
            onBlur={formik.handleBlur}
            variant="filled"
            style={{ marginTop: 11 }}
          />
          <Input
            label="Hasło"
            id="haslo"
            name="haslo"
            type={showPassword ? "text" : "password"}
            value={formik.values.haslo}
            onChange={formik.handleChange}
            error={formik.touched.haslo && Boolean(formik.errors.haslo)}
            helperText={formik.touched.haslo && formik.errors.haslo}
            onBlur={formik.handleBlur}
            InputProps={{
              disableUnderline: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            variant="filled"
          />
          <NotRememberPassword
            onClick={() => navigate("/forgotten-password-send-mail")}
          >
            Nie Pamiętam Hasła
          </NotRememberPassword>
          <StyledButton type="submit" variant="contained">
            Zaloguj się
          </StyledButton>
        </FormWrapper>
      </LoginForm>
    </LayoutAccount>
  );
};

const NotRememberPassword = styled.span`
  font-family: ${theme.fonts.interBold};
  color: ${theme.colors.black_primaryText};
  font-weight: ${theme.fontWeight.normal};
  font-size: 14px;
  line-height: 20px;
  text-align: right;
  // width: 412px;
  @media ${theme.device.Mtablet} {
    // width: 320px;
  }
  margin-right: 10px;
  text-decoration-line: underline;
  cursor: pointer;
`;
const LoginForm = styled.form`
  width: 100%;
  //min-width:260px;
  //max-width:430px;
`;
